import SeoLandingTemplate, { SeoLandingPageData } from "@/components/marketing/SeoLandingTemplate";

const page: SeoLandingPageData = {
  path: "/how-to-prepare-for-an-interview",
  title: "How to Prepare for an Interview",
  seoTitle: "How to Prepare for an Interview | HiredCoach",
  seoDescription:
    "A practical interview preparation guide covering research, answer practice, story prep, and mock interview rehearsal.",
  heroEyebrow: "Prep guide",
  heroHeadline: "Interview prep gets a lot better once you stop pretending notes are enough",
  heroSubhead:
    "Good prep is not fifty browser tabs and a highlighted job description. It is knowing the themes, tightening the stories, and actually hearing your answers before the stakes are real.",
  heroPrimaryCta: "Run a quick mock",
  heroPanelEyebrow: "What actually works",
  heroPanelTitle: "A real prep session includes",
  heroPanelBullets: [
    "Know the role",
    "Pick the likely questions",
    "Prep your stories",
    "Run at least one mock",
  ],
  heroPanelFooter: "Otherwise you are mostly hoping.",
  frameworkTitle: "What a real prep session includes",
  frameworkBullets: [
    "Read the job description like it matters.",
    "Prep your opening, your value pitch, and your weakness answer.",
    "Build stories for conflict, pressure, wins, and mistakes.",
    "Run a mock so the weak spots show up early.",
  ],
  exampleTitle: "What solid prep feels like",
  exampleBlocks: [
    "You know your story.",
    "Your best examples are not scattered.",
    "You can answer the obvious questions without drifting into word soup.",
  ],
  mistakesTitle: "What bad prep usually looks like",
  mistakes: [
    "You stay in note mode forever.",
    "You prep generic answers that could fit any job.",
    "You ignore transitions and follow-up questions.",
    "You skip mock interviews because they feel awkward. Yeah. They still help.",
  ],
  ctaEyebrow: "Coach U + practice",
  ctaTitle: "Run a mock interview",
  ctaBullets: [
    "Learn the framework",
    "Put your answers under pressure",
    "Find what still slips",
    "Fix it before it matters",
  ],
  ctaInfoCard: {
    title: "Coach U interview prep content",
    path: "/public-learn",
    description: "Read the Coach U content, then use HiredCoach to rehearse for the real thing.",
  },
  ctaActionTitle: "Run a quick mock",
  ctaActionDescription: "Take the prep out of your head and put it through a few real reps.",
  relatedTitle: "More interview questions worth actually practicing",
  relatedLinks: [
    {
      title: "Common Interview Questions",
      path: "/common-interview-questions",
      description: "Use this hub page to prepare for the most common interview questions and jump into deeper answer guides and mock interview practice.",
    },
    {
      title: "Interview Tips",
      path: "/interview-tips",
      description: "Practical interview tips for answering clearly, sounding confident, and avoiding the mistakes that make strong candidates feel unprepared.",
    },
    {
      title: "Mock Interview Practice",
      path: "/mock-interview-practice",
      description: "Practice mock interviews with AI feedback, sharpen common interview answers, and turn Coach U frameworks into real interview reps.",
    },
  ],
  faqs: [
    { question: "How many days before an interview should you prepare?", answer: "As early as you can, but one focused session with real practice beats a week of vague prep." },
    { question: "Is a mock interview worth it?", answer: "Yes. It shows you where your answer falls apart before the real interview has to do it." },
  ],
};

export default function HowToPrepareInterviewPage() {
  return <SeoLandingTemplate page={page} />;
}
